import { NATIVE_APP_AD_ELIGIBILITY_KEY, NATIVE_APP_BANNER_DISMISS_KEY } from "utilities/Constant";

export function clearNativeAppPromoSessionStorage(): void {
  sessionStorage.removeItem(NATIVE_APP_BANNER_DISMISS_KEY);
  sessionStorage.removeItem(NATIVE_APP_AD_ELIGIBILITY_KEY);
  for (let i = sessionStorage.length - 1; i >= 0; i -= 1) {
    const key = sessionStorage.key(i);
    if (key?.startsWith(`${NATIVE_APP_AD_ELIGIBILITY_KEY}:`)) {
      sessionStorage.removeItem(key);
    }
  }
}
